import React from "react";

const NavigationSwiper = ({ opacity = 100 }) => {
  // Konversi 0-100 ke 0-1
  const decimalOpacity = opacity / 100;

  return (
    <>
      <button 
        style={{ opacity: decimalOpacity }}
        className="swiper-button-prev-custom absolute left-4 top-1/2 -translate-y-1/2 z-50 w-14 h-14 bg-white/20 dark:bg-slate-800/20 backdrop-blur-md rounded-full flex items-center justify-center shadow-sm text-slate-700 dark:text-slate-200 opacity-0 group-hover:opacity-100 transition-all duration-500 hover:bg-white/40 hover:scale-110 border border-white/30 pointer-events-auto"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </button>

      <button 
        style={{ opacity: decimalOpacity }}
        className="swiper-button-next-custom absolute right-4 top-1/2 -translate-y-1/2 z-50 w-14 h-14 bg-white/20 dark:bg-slate-800/20 backdrop-blur-md rounded-full flex items-center justify-center shadow-sm text-slate-700 dark:text-slate-200 opacity-0 group-hover:opacity-100 transition-all duration-500 hover:bg-white/40 hover:scale-110 border border-white/30 pointer-events-auto"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </button>

      <style dangerouslySetInnerHTML={{ __html: `
        .swiper-pagination { bottom: 25px !important; z-index: 50 !important; }
        .swiper-pagination-bullet { background: #cbd5e1 !important; opacity: ${decimalOpacity * 0.5} !important; pointer-events: auto !important; }
        .swiper-pagination-bullet-active { background: #2563eb !important; width: 28px !important; border-radius: 6px !important; opacity: ${decimalOpacity} !important; }
      `}} />
    </>
  );
};

export default NavigationSwiper;